import { Expose } from 'class-transformer';
import { Model } from '@shared-features/models/model';
import { assignableFleet } from './assignable-fleet';
import { PricingMethod } from '@shared-features/enums/pricing-method';
import { UnitsType } from '@shared-features/enums/units-type';

export class FleetConfiguration extends Model {
  @Expose() id: number;
  @Expose() activateDispatchConfig?: boolean;
  @Expose() allowToSeePrice?: boolean;
  @Expose() allowToSelectAllDriversAndTrucks?: boolean;
  @Expose() assignableFleets?: assignableFleet[];
  @Expose() autoAssignAfterCancellation?: boolean;
  @Expose() autoAssignAfterReminder?: boolean;
  @Expose() selfAssigned?: boolean;
  @Expose() isZeroShipmentPrice?: boolean;
  @Expose() pricingMethod?: PricingMethod;
  @Expose() units?: UnitsType;
  @Expose() intervalDriverCaptureLocation: string;
  @Expose() idleIntervalDriverCaptureLocation?: number;
  @Expose() fleetDeductionPercentage?: number;
  @Expose() firstXKg?: number;
  @Expose() firstXKgPriceVendor?: number;
  @Expose() additionalKgPriceVendor?: number;
  @Expose() additionalKgPriceFleet?: number;
  @Expose() firstXKgPriceFleet?: number;
  @Expose() dimensionalWeightDivisor?: number;
  @Expose() madarAggregatorFeeLeFirstX?: number;
  @Expose() madarAggregatorFeeGtFirstX?: number;
  @Expose() madarIntegratorFee?: number;
  @Expose() fuelChargePercentage?: number;
  @Expose() whatsAppOnboardingEnabled?: boolean;
  @Expose() dnAiVerificationEnabled?: boolean;
  constructor() {
    super();
  }
}
